module.exports = __webpack_public_path__ + "img/About_fw_3.8ae2e86a.png";